import type { Card } from '@whispers/sdk';
import { useEffect } from 'react';

import { getCardUrl } from './getCardUrl.js';

export const usePreloadCardImages = (cards: Card[], deckSlug: string | undefined): void => {
  useEffect(() => {
    if (!deckSlug || cards.length === 0) {
      return;
    }

    new Image().src = getCardUrl({ deckSlug, slug: 'back' });
    for (const card of cards) {
      new Image().src = getCardUrl({ deckSlug, slug: card.slug });
    }
  }, [cards, deckSlug]);
};
